import { styledDefaultColDef } from '../../../extras/cellRenderers';

export const defaultColDef = {
  ...styledDefaultColDef,
  filter: true,
  flex: 1,
  minWidth: 200,
};

// export const detailCellRendererParams = () => {
//   return {
//     detailGridOptions: {
//       columnDefs: [
//         {
//           field: ''
//         }
//       ]
//     }
//   }
// }

export const columnDefs = [
  {
    headerName: 'User Id',
    field: 'userid',
    valueGetter: (params) => {
      return params?.data?.userId;
    },
  },
  {
    headerName: 'Name',
    field: 'name',
    valueGetter: (params) => {
      const firstName = params.data.firstName || '';
      const lastName = params.data.lastName || '';
      return `${firstName} ${lastName}`.trim();
    },
    
  },
  {
    headerName: 'Program',
    field: 'program',
    valueGetter: (params) => {
      const courseType = params.data.courseType || '';
      const planType = params.data.planType || '';
      const subPlanType = params.data.subPlanType || '';
      return `${courseType} ${planType} ${subPlanType}`.trim();
    },
   
  },
  {
    headerName: 'Email',
    field: 'email',
    
  },
  {
    headerName: 'Phone',
    field: 'phone',
    
  },
  {
    headerName: 'Cohort Name',
    field: 'cohortName',
    
  },
  {
    headerName: 'Almax Cohort Name',
    field: 'almaxCohortName',
    
  },
  {
    headerName: 'Enrolment On',
    field: 'enrolmentOn',
    
  },
  {
    headerName: 'Progress',
    field: 'progress',
    
  },
  {
    headerName: 'Progress Updated At',
    field: 'progressUpdatedAt',
    
  },
  {
    headerName: 'POC',
    field: 'POC',
    
  },
  {
    headerName: 'Contact Date',
    field: 'contactDate',
    
  },
  {
    headerName: 'Call Status',
    field: 'callStatus',
    
  },
  {
    headerName: 'Overall Remark',
    field: 'overallRemark',
    tooltipField: 'overallRemark',
    tooltipValueGetter: (params) => params.value,
  },
  {
    headerName: 'POC Remark',
    field: 'pocRemark',
    tooltipField: 'pocRemark',
    tooltipValueGetter: (params) => params.value,
    
  },
  {
    headerName: 'Care',
    field: 'care',
    
  },
  {
    headerName: 'Exotel Reference',
    field: 'exotelReference',
    
  },
  {
    headerName: 'QA Status',
    field: 'qaStatus',
    
  },
  {
    headerName: 'QA Remark',
    field: 'qaRemark',
    tooltipField: 'qaRemark',
    tooltipValueGetter: (params) => params.value,
  },
  {
    headerName: 'Calling Round',
    field: 'callingRound',
    
  },
  {
    headerName: 'Average Rating',
    field: 'averageRating',
    
  },
  {
    headerName: 'Upload Name',
    field: 'type-name',
    
  },
]; 